import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import PasswordForm from '../../../../shared/components/PasswordForm';
import { AuthRoutes } from '../../../../routes/routeConstants/appRoutes';
import AuthService from '../../../../services/AuthService/authService.service';

const ResetForm: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { resetPassword, cancelResetPassword } = AuthService();
  const { mutate: cancelReset, isPending: cancelResetPending } = useMutation(cancelResetPassword(id));
  const { mutate: setPassword, isPending: resetPending } = useMutation(resetPassword(id));

  const handleSubmit = (newPassword: string) => {
    setPassword({ newPassword }, { onSuccess: () => navigate(AuthRoutes.LOGIN) });
  };

  const handleCancel = () => {
    cancelReset(undefined, { onSuccess: () => navigate(AuthRoutes.LOGIN) });
  };

  return <PasswordForm onSubmit={handleSubmit} onCancel={handleCancel} isSubmitting={resetPending} isCancelling={cancelResetPending} />;
};

export default ResetForm;
